module.exports = __webpack_public_path__ + "img/numbers-chart.cc7193df.svg";